import React, { Component, createElement } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

import { NonEmptyValidationRule } from 'core/validation';

import { localeStrings as strings } from 'applicationConfig';

@observer
class Field extends Component {
  constructor(props, context) {
    super(props, context);

    if (!context._connectedForm) {
      throw new Error('Field must be inside a component decorated with connectedForm()');
    }

    this.validationRules = [];
  }

  get formStore() {
    return this.context._connectedForm.store;
  }

  get fieldName() {
    return this.props.name;
  }

  onChange = (event) => {
    event.stopPropagation();

    const { name, type } = this.props;
    const value = type !== 'checkbox' ? event.target.value : event.target.checked;

    this.formStore.onChangeFieldValue(name, value);
    // if (type !== 'checkbox') {
    //   event.preventDefault();
    // }
  };

  onChangeCustomComponent = (value, name) => {
    this.formStore.onChangeFieldValue(name, value);
  };

  onBlur = (event) => {
    event.preventDefault();
  };

  onFocus = (event) => {
    event.preventDefault();
  };

  onDragStart = (event) => {
    event.preventDefault();
  };

  onDrag = (event) => {
    event.preventDefault();
  };

  renderChildren() {
    return React.Children.map(this.props.children, (child) => {
      return React.cloneElement(child, {
        validationRules: this.validationRules
      });
    });
  }

  componentWillMount() {
    if (!this.props.optional && !this.validationRules.length) {
      // this makes all fields required by default
      new NonEmptyValidationRule(strings.generic.errorMessages.requiredField).register(this.validationRules);
    }
    this.formStore.setFieldValidationRules(this.fieldName, this.validationRules);
  }

  componentDidMount() {
    this.formStore.onChangeFieldValue(this.fieldName, this.formStore.values[this.fieldName], true);
  }

  componentWillUnmount() {
    this.formStore.clearFieldValidationRules(this.fieldName);
  }

  render() {
    const connectedForm = this.context._connectedForm;
    const { component, optional, name, type, placeholder, onPaste, readOnly, maxLength, ...rest } = this.props;
    const { errors, values, isValid } = connectedForm.store;
    let input = {
      onChange: this.onChange,
      onBlur: this.onBlur,
      onFocus: this.onFocus,
      onDragStart: this.onDragStart,
      onDrag: this.OnDrag,
      autoComplete: this.autoComplete,
      type,
      name,
      placeholder,
      onPaste,
      readOnly,
      maxLength
    };

    if (type === 'checkbox') {
      input = Object.assign(input, { value: '', checked: values[name], type });
    } else {
      input = Object.assign(input, { value: values[name] });
    }

    if (typeof component === 'string') {
      return createElement(component, { ...rest, ...input }, this.renderChildren());
    } else {
      input.onChangeCustomComponent = this.onChangeCustomComponent;

      return createElement(
        'span',
        {},
        [ createElement(component, { key: name, input, meta: { values, errors, isValid }, ...rest }) ].concat(
          this.renderChildren()
        )
      );
    }
  }
}

Field.contextTypes = {
  _connectedForm: PropTypes.object
};
export default Field;



// WEBPACK FOOTER //
// ./src/common/core/forms/Field.js